import Layout from '@/layout'

const joinsRouter = {
    path: '/joins',
    component: Layout,
    meta: {
        title: '我要加盟'
    },
    children: [
        {
            path: '',
            name: 'Joins',
            component: () => import('@/views/joins/index')
        }
    ]
}

export default joinsRouter